module.exports = __webpack_public_path__ + "media/newstyle/images/icon-a4-729e14be826ae6fe8cedba21298ac250.svg";